export const BlogListHeader = () => {
  return `
        query BlogListHeader($pagination: PaginationArg, $filters: BlogFiltersInput, $sort: [String], $status: PublicationStatus, $locale: I18NLocaleCode) {
  blogs(pagination: $pagination, filters: $filters, sort: $sort, status: $status, locale: $locale) {
    author {
      documentId
      avatar {
        caption
        name
        url
        publishedAt
        size
        updatedAt
        width
        documentId
      }
      name
    }
    slug
    short_description
    publishedAt
    title
    locale
    updatedAt
    priority
    media {
      name
      size
      url
      updatedAt
      width
      caption
    }
    documentId
    category {
      name
      slug
    }
      mobile_media {
      alternativeText
      caption
      url
    }
  }
}`;
};
